import React, { useState, useEffect } from 'react';
import { HOST } from "../../store/types";
import GetCards from "../../components/GetCards/GetCards";
import ToggleView from "../../components/ToggleView/ToggleView";
import {
    ContainerForToggleViewStyled,
    HeaderStyled,
    NumberPassedStyled,
    ContainerStyled
} from './style.js';
import i18n from "i18next";

import { Container } from "../../components/Container/Container";
import { ContainerCatalogStyled } from "../../components/Container/style";

const Events = ({ isMobile }) => {
    const [dashboard, setDashboard] = useState(true);
    const [total, setTotal] = useState(0);

    // переключение режима показа карточек на странице
    const _onToggleViewClick = (x) => {
        setDashboard(x);
    };

    // componentDidMount: получаем количество прошедших мероприятий
    useEffect(() => {
        let mounted = true;

        fetch(`${HOST}/v1/events?group=1`)
            .then((res) => {
                return res.json();
            })
            .then((body) => {
                if (mounted) setTotal(body.data.ended.total);
            });

        return () => { mounted = false };
    }, []);

    const now = new Date();
    const year = now.getFullYear();

    return (
        <ContainerCatalogStyled>
            <GetCards sourceCards="slides" contentType={(i18n.language === 'en') ? 'event' : 'мероприятие'} plug="true" cardDisplayType="topbanner" isMobile={isMobile} />
            <Container padding="true">
                <ContainerStyled>
                    <ContainerForToggleViewStyled>
                        <ToggleView selected={dashboard ? "dashboard" : "list"} toggleViewChange={(x) => _onToggleViewClick(x)} />
                    </ContainerForToggleViewStyled>
                    <GetCards sourceCards="events?sort%5Bcolumn%5D=date_end&sort%5Border%5D=asc" type="events" title={year + 1} cardDisplayType="grid" tile={dashboard} />
                    <GetCards sourceCards="events?sort%5Bcolumn%5D=date_end&sort%5Border%5D=asc" type="events" title={year} cardDisplayType="grid" tile={dashboard} />
                    {total > 0 && <HeaderStyled>{i18n.t(`events.past`)}<NumberPassedStyled> ({total})</NumberPassedStyled></HeaderStyled>}
                    <GetCards sourceCards="events?sort%5Bcolumn%5D=date_end&sort%5Border%5D=asc" type="events" title={year} past={true} cardDisplayType="grid" tile={dashboard} />
                    <GetCards sourceCards="events?sort%5Bcolumn%5D=date_end&sort%5Border%5D=asc" type="events" title={year - 1} cardDisplayType="grid" tile={dashboard} />
                </ContainerStyled>
            </Container>
        </ContainerCatalogStyled>
    );
};

export default Events;
